var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook (1)",
    clipPath: "url(#clip0_231_22045)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624374",
    width: 62.0001,
    height: 62,
    rx: 24.8,
    fill: "url(#paint0_linear_231_22045)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.9641 13.2555H18.0398C15.3989 13.2555 13.2578 15.3964 13.2578 18.0375V43.9617C13.2578 46.6029 15.3987 48.7437 18.0398 48.7437H30.8253L30.8475 36.0626H27.5525C27.1243 36.0626 26.7768 35.7162 26.7754 35.288L26.7592 31.2001C26.7576 30.7698 27.1064 30.4197 27.5367 30.4197H30.8258V26.4699C30.8258 21.8863 33.6252 19.3904 37.7141 19.3904H41.0696C41.4986 19.3904 41.847 19.7385 41.847 20.1679V23.6145C41.847 24.0439 41.499 24.392 41.0701 24.392L39.0108 24.3932C36.7871 24.3932 36.3563 25.4497 36.3563 27.0007V30.4202H41.2425C41.7085 30.4202 42.0696 30.8269 42.0145 31.2888L41.53 35.3768C41.4838 35.7682 41.1519 36.0628 40.758 36.0628H36.3783L36.3561 48.7444H43.964C46.6049 48.7444 48.7459 46.6032 48.7459 43.9623V18.0375C48.7461 15.3965 46.605 13.2555 43.9641 13.2555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.8254 48.7435L30.8477 36.0624H30.793V48.7435H30.8254Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_22045",
    x1: 31,
    y1: 0,
    x2: 31,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E598F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24306D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_22045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.0001,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a8220d811b56137f0095961da07944bd.svg";
export { ForwardRef as ReactComponent };